import { createSlice } from "@reduxjs/toolkit";
import dayjs from "dayjs";
const initialState = {
  HeadObject: {
    Type: "",
    VoucherTypeName: "",
    VoucherTypeCode: "",
    RefDate: new Date(),
    VoucherNo: "",
    Version: "",
    PartyCode: "",
    PartyName: "",
    ExpiryDate: new Date(),
    PoNetAmount: "",
    NoOfLineItems: "",
    GRNDate: new Date(),
    InvNo: "",
    InvDate: new Date(),
    AllocateReceiver: "",
    UnloadingBay: "",
    ExpStartTime: dayjs().format("hh:mm:ss"),
    ExpFinishTime: dayjs().format("hh:mm:ss"),
    TotalTimeinMin: "",
    GRNNetAmt: "",
    NoOfItems: "",
  },
  Title: {
    modalTitle: "",
    trntype: "",
  },
};

const SliceWmsDashboard = createSlice({
  name: "SliceWmsDashboard",
  initialState: { value: initialState },

  reducers: {
    //including   RESET ALL
    Set_WmsDashboard_Init: (state) => {
      state.value = initialState;
    },
    Set_HeadObject_Init: (state) => {
      state.value.HeadObject = initialState.HeadObject;
    },
    Set_WmsDashboard_HeadObject_Set: (state, action) => {
      state.value.HeadObject = action.payload;
    },
    Set_Title_Init: (state) => {
      state.value.Title = initialState.Title;
    },
    Set_WmsDashboard_Title_Set: (state, action) => {
      state.value.Title = action.payload;
    },
  },
});

export const {
  Set_WmsDashboard_Init,
  Set_WmsDashboard_HeadObject_Set,
  Set_HeadObject_Init,
  Set_Title_Init,
  Set_WmsDashboard_Title_Set,
} = SliceWmsDashboard.actions;
export default SliceWmsDashboard.reducer;
